import Axios from "axios";

const API_URL = process.env.REACT_APP_FASTAPI_BACKEND_URL;
Axios.defaults.baseURL = API_URL;

export class FastApiService {
  _axios = Axios.create();

  addRequestInterceptor = (onFulfilled, onRejected) => {
    this._axios.interceptors.request.use(onFulfilled, onRejected);
  };

  addResponseInterceptor = (onFulfilled, onRejected) => {
    this._axios.interceptors.response.use(onFulfilled, onRejected);
  };

  get = async (url) => await this.request(this.getOptionsConfig("get", url));

  getWithHeaders = async (url, headers) => {
    await this._axios.request({
      method: "get",
      url,
      headers,
    });
  };

  getBlobResponse = async (url) => {
    return await this._axios.get(url, {
      responseType: "blob",
    });
  };

  getSlideResponse = async (url) => {
    return await this._axios.get(url, {
      responseType: "application/pdf",
    });
  };

  post = async (url, data) =>
    await this.request(this.getOptionsConfig("post", url, data));

  postWithHeaders = async (url, data, headers) => {
    return await this._axios.request({
      method: "post",
      url,
      data,
      headers,
    });
  };

  put = async (url, data) =>
    await this.request(this.getOptionsConfig("put", url, data));

  patch = async (url, data) =>
    await this.request(this.getOptionsConfig("patch", url, data));

  delete = async (url) =>
    await this.request(this.getOptionsConfig("delete", url));

  getOptionsConfig = (method, url, data) => {
    return {
      method,
      url,
      data,
      headers: { "Content-Type": "application/json" },
    };
  };

  request(options) {
    return new Promise((resolve, reject) => {
      this._axios
        .request(options)
        .then((res) => resolve(res.data))
        .catch((ex) => {
          // Check if the response object exists
          if (ex.response && ex.response.data) {
          } else {
            // Handle cases where the error does not have a response object
          }
        });
    });
  }
}

export default new FastApiService();
